import { usePathname, useRouter } from "expo-router";
import React, { useCallback } from "react";
import { Platform } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

import CustomHeaderView from "./CustomHeaderView";

import { useCurrentUser } from "@/features/auth";
import { filterValuesVar } from "@/features/player-filter";
import { useClientFeatureFlags } from "@/hooks/useClientFeatureFlags";
import useMobileScreen from "@/hooks/useMobileScreen";
import { useTheme } from "@/providers/ThemeProvider";
import { navigateToHome } from "@/utils/navigateToHome";

/**
 * Container component for application header with navigation and user context
 */
function CustomHeaderContainer() {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const router = useRouter();
  const pathname = usePathname();
  const currentUser = useCurrentUser();
  const { leftSidebarEnabled } = useClientFeatureFlags();
  const cognitoAttributes =
    currentUser?.cognitoUser?.Attributes ??
    currentUser?.cognitoUser?.UserAttributes ??
    [];
  const firstName =
    cognitoAttributes.find(({ Name: name }) => name === "given_name")?.Value ??
    null;
  const isSmallScreen = useMobileScreen();

  // Hide navigation icons in header when sidebar is enabled on web
  const showNavigationIcons = !leftSidebarEnabled || Platform.OS !== "web";

  const handleLogoPress = useCallback(() => {
    filterValuesVar(null);
    navigateToHome(router, pathname);
  }, [router, pathname]);

  const handleKanbanToggle = useCallback(() => {
    router.navigate("/player-kanban");
  }, [router]);

  return (
    <SafeAreaView edges={["top"]} className="bg-surface-base">
      <CustomHeaderView
        firstName={firstName}
        onLogoPress={handleLogoPress}
        onKanbanToggle={handleKanbanToggle}
        isSmallScreen={isSmallScreen}
        isDark={isDark}
        showNavigationIcons={showNavigationIcons}
      />
    </SafeAreaView>
  );
}

export default CustomHeaderContainer;
